import { WORDS_STEP } from '../constants';
import { normalizePages, normalizeWords } from '../utils';

export const decPages = (args, state, tools) => {
  tools.changeValue(state, 'pages_qty', pages => normalizePages(parseInt(pages, 10) - 1));
};

export const incPages = (args, state, tools) => {
  tools.changeValue(state, 'pages_qty', pages => normalizePages(parseInt(pages, 10) + 1));
};

export const decWords = (args, state, tools) => {
  tools.changeValue(state, 'words_qty', words => normalizeWords(parseInt(words, 10) - WORDS_STEP));
};

export const incWords = (args, state, tools) => {
  tools.changeValue(state, 'words_qty', words => normalizeWords(parseInt(words, 10) + WORDS_STEP));
};

export const applyPaperType = ([paper_type], state, { changeValue }) => {
  if (paper_type) {
    changeValue(state, 'paper_type', () => paper_type);
  }
};

export const applyPages = ([pages_qty], state, { changeValue }) => {
  if (pages_qty) {
    changeValue(state, 'pages_qty', () => pages_qty);
  }
};
export const applyPaperSizeType = ([paperSizeType], state, { changeValue }) => {
  if (paperSizeType) {
    changeValue(state, 'paper-size-type', () => paperSizeType);
  }
};

export const applyWords = ([words_qty], state, { changeValue }) => {
  if (words_qty) {
    changeValue(state, 'words_qty', () => words_qty);
  }
};
